export function upravNavigaci() {
  Lc.f("upravNavigaci");
  $("#dvBMenu a").click(function(e) {
    Lc.f("dvBMenu a click");
    $("#dvScrollMenu").addClass("show");

    e.preventDefault();
  });

  $("#dvScrollMenu a.aClose").click(function(e) {
    Lc.f("dvBMenu a click");
    $("#dvScrollMenu").removeClass("show");

    e.preventDefault();
  });
}
